import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const ContextManipulationWidget: WidgetRegistryEntry = {
  name: "ContextManipulation",
  configuration: () => import("./configuration").then((m) => m.ContextManipulationWidgetConfiguration),
  component: () => import("./context-manipulation-widget.component").then((m) => m.ContextManipulationWidgetComponent)
};
